var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", [
    _c("div", { staticClass: "footer box" }, [
      _c("div", { staticClass: "link-box" }, [
        _c(
          "ul",
          { attrs: { id: "linklist" } },
          [
            _vm._m(0),
            _vm._v(" "),
            _vm._l(_vm.relatedWebsitesList, function(item, index) {
              return _c("li", { key: index }, [
                _c(
                  "a",
                  { attrs: { href: item.websiteAddress, target: "_blank" } },
                  [_vm._v(_vm._s(item.name))]
                )
              ])
            })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "clear" }),
    _vm._v(" "),
    _c("div", { staticClass: "footer-line" }),
    _vm._v(" "),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("span", [_vm._v("友情链接：")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "end-nav" }, [
        _c("img", {
          attrs: { src: require("../../assets/images/dzjg.png"), alt: "" }
        }),
        _vm._v(" "),
        _c("p", [
          _vm._v("联系电话：0371-65510463"),
          _c("span", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v("地址：郑州市丰产路93号")
          ]),
          _c("span", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v("投稿信箱：hnsbzxxk@163.com")
          ])
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("河南省水土保持监测总站@版权所有")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fd56c96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fd56c96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Footer.vue
// module id = null
// module chunks = 